import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';

class SaveNExit extends Component{ 

    constructor()
    {
        super();
        window.scrollTo(0,0);
    }
    
    render(){
        return <>
            <Grid>
                <GridRow>
                    <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]}>
                        <GridRow>
                            <GridColumn >
                                <Heading className = "textBold" variant="pageTitle"><Translate value="uplevelRenewal.msg_data_saved" /></Heading>
                                <p><Translate value="uplevelRenewal.save_n_exit_body" /></p>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </>
    }
}

export default SaveNExit;